module.exports = __webpack_public_path__ + "img/puzzlebg.5007867d.jpeg";